
define('text!modules/reporting/segments/dataExport/manage/templates/manage.html',[],function () { return '<div class="header"></div>\n<div class="clear-fix"></div>\n<div class="grid"></div>\n<div class="clear-fix"></div>';});

